__turbopack_context__.v({
  "className": "geist_mono_4f4439b9-module__JuRlHq__className",
  "variable": "geist_mono_4f4439b9-module__JuRlHq__variable",
});
